import { render, staticRenderFns } from "./globalMenuDropdownItem.vue?vue&type=template&id=bf1c8b94&"
import script from "./globalMenuDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./globalMenuDropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./globalMenuDropdownItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports